import MiniLogo from '@assets/icons/tarumt-icon.svg';
import moment from 'moment';
import './styles.css';
import FacebookLogo from '@assets/icons/facebook-icon.svg';

const Footer = () => {
	return (
		<div className="footer">
			<div className="footer-container">
				<div className="footer-follow">
					<h2>FOLLOW US</h2>
					<div className="social-icons">
						<a href="https://www.facebook.com/tarcalumni/#">
							<img
								src={FacebookLogo}
								alt="facebook-logo"
								style={{ width: '24px', height: '24px' }}
							/>
						</a>
						<a href="https://www.tarc.edu.my/">
							<img src={MiniLogo} alt="mini-logo" style={{ height: '26px' }} />
						</a>
					</div>
				</div>

				<div className="footer-contact">
					<h2>CONTACT US</h2>
					<div className="footer-contact-info">
						<div
							className="contact-left"
							style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
						>
							<div>Phone : +6011-5589 5238</div>
							<div>Email : admin@tarcalumni.my</div>
						</div>
						<div className="contact-right">
							Address : Block E-2-6 Plaza Damas,
							<br />
							60, Jalan Sri Hartamas 1,
							<br />
							Sri Hartamas,
							<br />
							50480 Kuala Lumpur.
						</div>
					</div>
				</div>
			</div>

			<div className="footer-copyright">
				<div>© {moment().format('YYYY')} TARCian Alumni Association</div>
			</div>
		</div>
	);
};

export default Footer;
